module.exports = __webpack_public_path__ + "img/vignettes-asso_0006_j2p.a9dffa7b.jpg";